const _measurementLabels: Record<string, number> = {}

export const MEASUREMENT_LABELS = {
  HOMEPAGE: 'homepage',
  ONBOARDING: 'onboarding',
}

// Only measure on direct page loads, not SPA navigations, and only once per session
export function shouldMeasure(): boolean {
  const isDirectLoad = window.location.pathname === window.landingPath
  const alreadyMeasured = Object.keys(_measurementLabels).length > 0
  return isDirectLoad && !alreadyMeasured
}

export function measureTime(label: string): number {
  if (_measurementLabels[label]) {
    return _measurementLabels[label]
  }

  _measurementLabels[label] = Date.now() - window.requestTime
  return _measurementLabels[label]
}
